import { render, staticRenderFns } from "./CounselingQuestionAnswerForm.vue?vue&type=template&id=3653f5e9&"
import script from "./CounselingQuestionAnswerForm.vue?vue&type=script&lang=js&"
export * from "./CounselingQuestionAnswerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports